import React from 'react';
export function HeartIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.83c-.399 0-.792-.096-1.146-.28-2.36-1.237-7.94-4.706-8.754-10.215A6.637 6.637 0 013.538 5.11 5.746 5.746 0 017.8 3 6.038 6.038 0 0112 4.548 6 6 0 0116.2 3a5.746 5.746 0 014.26 2.108 6.64 6.64 0 011.44 5.227c-.815 5.509-6.394 8.978-8.755 10.214A2.467 2.467 0 0112 20.83zM8 5h-.137a3.767 3.767 0 00-2.789 1.39 4.7 4.7 0 00-1 3.65c.7 4.73 6.073 7.882 7.7 8.736a.466.466 0 00.44 0c1.63-.853 7-4.005 7.7-8.735a4.7 4.7 0 00-1-3.65A3.772 3.772 0 0016.136 5a4 4 0 00-3.053 1.284 1.532 1.532 0 01-2.168 0A3.98 3.98 0 008 5z"
  }));
}